<template>
  <div>
    <!-- Hidden trigger for the modal -->
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 bg-black/50 flex items-center justify-center animate-in fade-in-0"
    >
      <div
        class="bg-white rounded-lg shadow-lg p-6 max-w-sm w-full mx-4 animate-in zoom-in-95"
      >
        <!-- Header with warning icon -->
        <div class="flex items-center gap-3 mb-4">
          <div class="bg-yellow-100 p-2 rounded-full">
            <AlertTriangle class="w-6 h-6 text-yellow-600" />
          </div>
          <h2 class="text-lg font-bold text-gray-900">Confirm Booking</h2>
        </div>

        <!-- Main warning message -->
        <div class="mb-6 space-y-3">
          <p class="text-gray-700 font-semibold">
            You are about to book Smart Cards for all {{ bookingType }}.
          </p>

          <!-- Important notice box -->
          <div class="bg-blue-50 border border-blue-200 rounded-md p-3">
            <p class="text-sm text-blue-900">
              <span class="font-semibold">⚠️ Important:</span> Only Users with
              status <span class="font-bold text-blue-700">ACTIVE</span> cards
              will be booked.
            </p>
          </div>

          <p class="text-sm text-gray-600">
            This action cannot be undone. Please confirm to proceed.
          </p>
        </div>

        <!-- Loading state -->
        <div
          v-if="isLoading"
          class="mb-4 flex items-center gap-2 text-blue-600"
        >
          <div class="animate-spin">
            <Loader2 class="w-4 h-4" />
          </div>
          <span class="text-sm">Processing booking...</span>
        </div>

        <!-- Action buttons -->
        <div class="flex gap-3">
          <button
            @click="cancel"
            :disabled="isLoading"
            class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            @click="confirm"
            :disabled="isLoading"
            class="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg font-medium hover:bg-blue-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            <CheckCircle class="w-4 h-4" />
            <span class="text-[10px] sm:text-base">Confirm Booking</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { AlertTriangle, CheckCircle, Loader2 } from "lucide-vue-next";

  defineProps({
    isOpen: {
      type: Boolean,
      default: false,
    },
    bookingType: {
      type: String,
      default: "students", // 'students', 'teachers', 'both'
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });

  const emit = defineEmits(["confirm", "cancel"]);

  const confirm = () => {
    emit("confirm");
  };

  const cancel = () => {
    emit("cancel");
  };
</script>
